import React from 'react';
import PropTypes from 'prop-types';
import {Button} from "reactstrap";
import "./index.css";

ButtonWithImage.propTypes = {
    text: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    style: PropTypes.object,
    onClick: PropTypes.func.isRequired,
};

function ButtonWithImage(props) {
    return (
        <Button {...props} color={props.color} className="" style={props.style} onClick={props.onClick}>
            <img src={props.src} alt={props.text} height={18} style={{paddingBottom:3}}/>
            <span className="btn-primary-text">{props.text}</span>
        </Button>
    );
}

export default ButtonWithImage;